import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { interpolate, useAnimatedStyle, useSharedValue, withSequence, withTiming, } from 'react-native-reanimated';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useColorScheme from 'hooks/useColorScheme';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import FastImage from 'utils/packages/rnFastImage';
import TouchableBounce from 'utils/packages/TouchableBounce';
const ICON_FALLBACK_DARK = 'https://storage.googleapis.com/emma-app.com/images/icons/notifications/dark/emma_team.png';
const ICON_FALLBACK_LIGHT = 'https://storage.googleapis.com/emma-app.com/images/icons/notifications/light/emma_team.png';
const CreditScoreAlertItem = ({ item, style, shouldShake = false, onPress, }) => {
    const styles = useStyles(styleSet);
    const isDarkMode = useColorScheme() === 'dark';
    const rotationSharedValue = useSharedValue(0);
    const wiggleAnimatedStyle = useAnimatedStyle(() => ({
        transform: [
            {
                rotate: `${interpolate(rotationSharedValue.value, [0, 0.25, 0.5, 0.75, 1], [0, 5, 0, -5, 0])}deg`,
            },
        ],
    }), [rotationSharedValue]);
    const handlePress = useCallback(() => {
        if (shouldShake) {
            rotationSharedValue.value = withSequence(withTiming(1, { duration: 500 }), withTiming(0, { duration: 0 }));
            return;
        }
        onPress();
    }, [shouldShake, onPress, rotationSharedValue]);
    const iconFallback = isDarkMode ? ICON_FALLBACK_DARK : ICON_FALLBACK_LIGHT;
    const icon = isDarkMode ? item.iconUrl : item.coloredIconUrl;
    return (<Animated.View style={wiggleAnimatedStyle}>
      <TouchableBounce style={[styles.row, style]} onPress={handlePress}>
        <View style={styles.iconContainer}>
          <View style={styles.imageWrapper}>
            <FastImage source={{ uri: icon || iconFallback }} style={staticStyles.image} resizeMode="contain"/>
            {!item.isRead ? <View style={styles.notificationDot}/> : null}
          </View>
        </View>
        <View style={styles.description}>
          <Text Text-16 style={styles.title}>
            {item.heading}
          </Text>
          {item.text ? (<Text TextThin-14 Secondary>
              {item.text}
            </Text>) : null}
        </View>
      </TouchableBounce>
    </Animated.View>);
};
const staticStyles = StyleSheet.create({
    image: {
        width: rem(40),
        height: rem(40),
    },
});
const styleSet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
        padding: rem(16),
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    iconContainer: {
        width: rem(40),
        alignItems: 'center',
    },
    imageWrapper: {
        position: 'relative',
        width: rem(40),
        height: rem(40),
    },
    description: {
        flex: 1,
        marginLeft: rem(16),
        flexDirection: 'column',
    },
    title: {
        marginBottom: rem(4),
    },
    notificationDot: {
        position: 'absolute',
        top: rem(-3),
        right: rem(-3),
        width: rem(7),
        height: rem(7),
        borderRadius: rem(7),
        backgroundColor: colors.elements.statusNegative,
    },
}));
export default CreditScoreAlertItem;
